const GAUGE_MIN = -50;

const OVERFLOW_MULTIPLIER = {
  currentStamina: 5,
  currentLogique: 3,
  currentSocial: 3,
  currentSensoriel: 3,
  currentPassion: 3,
  currentMotivation: 3,
};

export function applyDeltas(deltas, currentGauges, baseGauges, maxGauges) {
  const isVolonteZero = (currentGauges.currentMotivation ?? 0) <= 0;
  const updates = {};
  let vitalDrain = 0;
  const negForStamina = [];

  for (const [gaugeKey, delta] of Object.entries(deltas)) {
    const baseKey = gaugeKey.replace("current", "");
    const max = maxGauges[baseKey] ?? 100;
    const cur = currentGauges[gaugeKey] ?? 0;

    if (gaugeKey === "currentReserve") {
      updates[gaugeKey] = Math.min(max, Math.max(0, cur + delta));
      continue;
    }

    const effectiveDelta = delta < 0 && isVolonteZero ? delta * 3 : delta;
    const newValue = Math.min(max, Math.max(GAUGE_MIN, cur + effectiveDelta));
    updates[gaugeKey] = newValue;

    if (delta < 0 && !isVolonteZero) {
      const additionalNeg = Math.max(0, Math.max(0, -newValue) - Math.max(0, -cur));
      if (additionalNeg > 0) {
        vitalDrain += additionalNeg * (OVERFLOW_MULTIPLIER[gaugeKey] ?? 3);
      }
    }

    if (delta < 0 && isVolonteZero && gaugeKey !== "currentStamina") {
      const profileVal = baseGauges[baseKey];
      if (profileVal) negForStamina.push({ amount: Math.abs(delta), profile: profileVal });
    }
  }

  if (vitalDrain > 0) {
    const curVital = currentGauges.currentReserve ?? 0;
    updates.currentReserve = Math.max(0, (updates.currentReserve ?? curVital) - vitalDrain);
  }

  if (negForStamina.length > 0) {
    const sumDeltas = negForStamina.reduce((s, v) => s + v.amount, 0);
    const sumProfiles = negForStamina.reduce((s, v) => s + v.profile, 0);
    const staminaDrain = Math.round(((sumDeltas / sumProfiles) * 100) / negForStamina.length);
    if (staminaDrain > 0) {
      const curStamina = currentGauges.currentStamina ?? 0;
      updates.currentStamina = Math.max(GAUGE_MIN, (updates.currentStamina ?? curStamina) - staminaDrain);
    }
  }

  return updates;
}
